import OSAByRetailer from "./OSAByRetailer";
export default OSAByRetailer;
